export default __webpack_public_path__ + "static/media/Icon=ArchiveTask.44d24358.svg";